<finxone-web-frontend-intl-beneficiary-address
  [editAddress]="editAddress"
  [formActionData]="formStateData"
  (handleAddressChange)="valueChange($event)"
>
</finxone-web-frontend-intl-beneficiary-address>
